import React, { useMemo, useState } from "react";
import { Heart, Star } from "lucide-react";
import { Link } from "react-router-dom";
import {
  useAddToCartMutation,
  useGetMyCartQuery,
  useRemoveFromCartMutation,
} from "../../services/cart";
import ConfirmModal from "../common/ConfirmModal";

const ExploreCourseCard = ({ course }) => {
  const { data: cartResponse } = useGetMyCartQuery();
  const [addToCart, { isLoading: isAddingToCart }] = useAddToCartMutation();
  const [removeFromCart, { isLoading: isRemovingFromCart }] =
    useRemoveFromCartMutation();
  const [showRemoveModal, setShowRemoveModal] = useState(false);
  
  
   
  const isCourseInCart = useMemo(
    () =>
      cartResponse?.data?.items.some((item) => {
        const id = item.course._id || null;
        return id != null && String(id) === String(course.id);
      }),
    [cartResponse?.data?.items,course.id],
  );



  const selectedCartItem = useMemo(
    () =>
      cartResponse?.data?.items.find((item) => {
        const id = item.course._id || null;
        return id != null && String(id) === String(course.id);
      }) || null,
    [cartResponse?.data?.items, course.id],
  );
  const handleAddToCart = async () => {
    if (!course.id || isCourseInCart || isAddingToCart) return;

    try {
      await addToCart({
        courseId: course.id,
        purchaseType: course.purchaseType || "Recorded Lectures",
        quantity: 1,
      }).unwrap();
    } catch (error) {
      console.error("Failed to add course to cart:", error);
    }
  };

  const handleHeartClick = () => {
    if (isCourseInCart) {
      setShowRemoveModal(true);
      return;
    }

    handleAddToCart();
  };

  const handleConfirmRemove = async () => {
    if (!selectedCartItem?._id || isRemovingFromCart) return;

    try {
      await removeFromCart(selectedCartItem._id).unwrap();
    } catch (error) {
      console.error("Failed to remove course from cart:", error);
    } finally {
      setShowRemoveModal(false);
    }
  };

  const handleCancelRemove = () => {
    setShowRemoveModal(false);
  };

  return (
    <div>
      <article key={course.title} className="bg-white">
        <div
          className="h-[220px] bg-cover bg-center"
          style={{ backgroundImage: `url(${course.image})` }}
        />
        <div className=" pt-2">
          <h4
            className="line-clamp-2 leading-6 sm:min-h-12 text-sm font-medium text-[#1D2026]"
            title={course.title}
          >
            {course.title}
          </h4>
          <div className="mt-2 border-t border-[#E9EAF0]" />
          <div className="mt-4 flex justify-between items-center gap-2 text-[15px] text-[#6B7280]">
            <div className="flex items-center gap-2">
              <Star size="16" color="#FACC15" fill="#FACC15"  />
              <span>4.8 <span className="">(256)</span> </span>
            </div>

            <span className="text-center">Rs {course.coursePrice ?? course.price}</span>
            <span className="flex justify-center">
              <button
                type="button"
                onClick={handleHeartClick}
                disabled={isAddingToCart || isRemovingFromCart}
                className="transition-opacity disabled:cursor-not-allowed disabled:opacity-60"
              >
                <Heart
                  size={18}
                  strokeWidth={1.8}
                  className={isCourseInCart ? "text-[#FF6636]" : "text-[#6B7280]"}
                  fill={isCourseInCart ? "#FF6636" : "none"}
                />
              </button>
            </span>
          </div>
          <Link
            to={`/student/view-course/${course.id}`}
            className="mt-6 justify-center flex  bg-[#FF6636] leading-10 text-sm font-semibold text-white tracking-[-0.4%]"
          >
            View
          </Link>
        </div>
      </article>
      <ConfirmModal
        open={showRemoveModal}
        title="Remove Course"
        message={
          <>
            Are you sure you want to remove{" "}
            <span className="font-bold">{course.title}</span> from your wishlist?
          </>
        }
        confirmLabel="Remove"
        onConfirm={handleConfirmRemove}
        onCancel={handleCancelRemove}
      />
    </div>
  );
};

export default ExploreCourseCard;
